// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"link-button_linkButton__x89JR","icon":"link-button_icon__woEEJ"};